import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IFormContentProps } from '@gem/components';
import { PopupHeader } from '@gem/ui-kit';

import { TAvatarBackgroundColorIndex } from 'APP/components/Avatar/Avatar';
import { GroupType } from 'APP/model/group/groupModel.types';

import { useGroupFormPresenter } from './GroupForm.presenter';
import { IGroupFormInitialValues, TSubmitHandler } from './GroupForm.types';
import { GroupFormGeneral } from './GroupFormGeneral/GroupFormGeneral';
import { GroupFormMembers } from './GroupFormMembers/GroupFormMembers';

interface IGroupFormProps {
  title: string;
  initialValues: IGroupFormInitialValues;
  avatarTitle?: string;
  avatarColor?: TAvatarBackgroundColorIndex;
  isShowMembers?: boolean;
  isEditMode?: boolean;
  onSubmit: TSubmitHandler;
  generalBottomDescription?: string;
  onClose(): void;
  onFormStateChange(state: Partial<IFormContentProps>): void;
}

export const GroupForm: FC<IGroupFormProps> = observer((props) => {
  const {
    title,
    initialValues,
    avatarTitle,
    avatarColor,
    isShowMembers = false,
    isEditMode = false,
    generalBottomDescription,
    onSubmit,
    onClose,
    onFormStateChange,
  } = props;

  const presenter = useGroupFormPresenter({ initialValues, isShowMembers, onSubmit });

  return (
    <>
      <PopupHeader
        title={title}
        handlePrevStep={presenter.isShowPrevStep ? presenter.onShowMembers : undefined}
        onClose={onClose}
      />
      {presenter.isShowMembers && (
        <GroupFormMembers
          membersIds={presenter.membersIds}
          onSetMembersIds={presenter.onSetMembersIds}
          onNextStep={presenter.onShowGeneralInfo}
          targetGroupType={GroupType.Closed}
        />
      )}
      {presenter.isShowGeneralInfo && (
        <GroupFormGeneral
          initialValues={presenter.initialValues}
          avatarTitle={avatarTitle}
          avatarColor={avatarColor}
          isEditMode={isEditMode}
          membersIds={presenter.membersIds}
          onUpdateGroupData={presenter.onUpdateGroupData}
          onSubmit={presenter.onSubmit}
          onFormStateChange={onFormStateChange}
          onImageLoad={presenter.onImageLoad}
          generalBottomDescription={generalBottomDescription}
        />
      )}
    </>
  );
});
